/* Vendor join application form: client-side validation only.
   The form posts natively to /contact; submit is blocked only when a required
   field fails, so Shopify's bot challenge and redirect keep working. */
(function () {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(form) {
    if (form.getAttribute('data-otcd-vj-ready')) return;
    form.setAttribute('data-otcd-vj-ready', 'true');

    var required = Array.prototype.slice.call(form.querySelectorAll('[required]'));
    var submitted = false;

    function isValid(field) {
      var value = field.value.trim();
      if (!value) return false;
      if (field.type === 'email') return emailPattern.test(value);
      return true;
    }

    function showState(field) {
      var error = document.getElementById(field.getAttribute('aria-describedby'));
      var ok = isValid(field);
      field.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (error) {
        error.textContent = ok ? '' : field.getAttribute('data-error');
        error.hidden = ok;
      }
      return ok;
    }

    required.forEach(function (field) {
      field.addEventListener('blur', function () { if (submitted) showState(field); });
      field.addEventListener('input', function () { if (submitted) showState(field); });
    });

    form.addEventListener('submit', function (event) {
      submitted = true;
      var firstInvalid = null;
      required.forEach(function (field) {
        if (!showState(field) && !firstInvalid) firstInvalid = field;
      });
      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
      }
    });

    // After the post redirects back, bring the confirmation into view.
    var done = form.querySelector('.otcd-vj-form__done');
    if (done) done.focus();
  }

  function initAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('form.otcd-vj-form'), init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
